import { Component } from "react";
import {Row , Col}  from 'react-grid-system';
import '../Assests/about.css';
import { Container, Image } from 'react-bootstrap';
import {GiSpeedometer} from 'react-icons/gi';
import {IoMdLaptop} from 'react-icons/io';
import {RiLightbulbFlashLine} from 'react-icons/ri';
import {BiRocket} from 'react-icons/bi';
import ProgressBar from 'react-bootstrap/ProgressBar';
import wa from '../Assests/images/wa.jpeg';






class About extends Component{
    render(){
        return (
            <Container className="bodyA">
                <br/>
                <Row>
                <Col xs sm="12" md lg="12">
                  <h1 className="abt">About</h1>
                </Col>
              
            </Row>
             <Row className="r1">
             <Col className="col">
             
             <GiSpeedometer className="icon"/>
             <h4 className="h4">Fast</h4>
             <p className="aboutp">Fast load times and lag free interaction, my highest priority.</p>
             </Col>
             <Col className="col"><IoMdLaptop className="icon"/>
             <h4 className="h4">Responsive</h4>
             <p className="aboutp">My layouts will work on any device, big or small.</p></Col>
           
             <Col className="col"><RiLightbulbFlashLine className="icon"/>
             <h4 className="h4">Intuitive</h4>
            <p className="aboutp">Strong preference for easy to use, intuitive UX/UI.</p>
             </Col>
             <Col className="col" ><BiRocket className="icon"/>
            <h4 className="h4">Dynamic</h4> 
           <p className="aboutp">Websites don't have to be static, I love making pages come to life.</p>
             </Col>
         </Row>
         <br/>
         <Row className="r2">
             <Col className="col">
             <Image  className="wa" src={wa}/>
             <h4 className="h">Who's this lady?</h4>
             <p className="aboutp">I'm a Front-End Developer.
              I have serious passion for UI effects, animations and creating intuitive, dynamic user experiences.
             <p className="pc"><a className="a" href="#">Let's make something special.</a></p></p>
             </Col>
             <Col className="col">
                 <p className="pr">Html</p>
                 <ProgressBar variant="success" now={90} label="90%" />
                 <br/>
                 <p className="pr">Css</p>
                 <ProgressBar variant="success" now={90} label="90%" />
                 <br/>
                 <p className="pr">JavaScript</p>
                 <ProgressBar variant="success" now={80} label="80%" />
                 <br/>
                 <p className="pr">Node.js</p>
                 <ProgressBar variant="success" now={50} label="50%" />
                 <br/>
                 <p className="pr">React</p>
                 <ProgressBar variant="success" now={70} label="70%" />
                 <br/>
                 <p className="pr">UI Design</p>
                 <ProgressBar variant="success" now={80} label="80%" />
                 <br/>
                 <p className="pr">Sketch</p>
                 <ProgressBar variant="success" now={80} label="80%" />
             </Col>
             </Row>
             <br/>
             <br/>
        

        
            </Container>
            
    );

}
}

  
export default About;